


/* fallback */

@font-face {
  font-family: 'Material Icons';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  // src: url('/assets/iconfont/material-icons.woff2') format('woff2'); // Local dev
  src: url('~@episource/signet/src/iconfont/material-icons.woff2') format('woff2'); // Production
}

/* fallback */

@font-face {
  font-family: 'Material Icons Sharp';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  // src: url('/assets/iconfont/material-icons-sharp.woff2') format('woff2');
  src: url('~@episource/signet/src/iconfont/material-icons-sharp.woff2') format('woff2');
}

/* fallback */

@font-face {
  font-family: 'Material Icons Outlined';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  // src: url('/assets/iconfont/material-icons-outlined.woff2') format('woff2');
  src: url('~@episource/signet/src/iconfont/material-icons-outlined.woff2') format('woff2');
}

/* fallback */

@font-face {
  font-family: 'Material Icons Round';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  // src: url('/assets/iconfont/material-icons-round.woff2') format('woff2');
  src: url('~@episource/signet/src/iconfont/material-icons-round.woff2') format('woff2');
}


@font-face {
  font-family: 'Material Icons Two Tone';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  // src: url('/assets/iconfont/material-icons-two-tone.woff2') format('woff2');
  src: url('~@episource/signet/src/iconfont/material-icons-two-tone.woff2') format('woff2');
}


// Shared icon style
%material-icon-base {
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: 'liga';
  -webkit-font-smoothing: antialiased;
}

.material-icons, .mi {
  font-family: 'Material Icons';
  @extend %material-icon-base;
}
.material-icons-sharp, .mi-sharp {
  font-family: 'Material Icons Sharp';
  @extend %material-icon-base;
}
.material-icons-outlined, .mi-outlined {
  font-family: 'Material Icons Outlined';
  @extend %material-icon-base;
}
.material-icons-round, .mi-round {
  font-family: 'Material Icons Round';
  @extend %material-icon-base;
}

/* fallback */


// Remove or clarify this variable if not used anywhere
// body {
//   --google-font-color-materialiconstwotone: none;
// }


.material-icons-two-tone, .mi-two-tone {
  font-family: 'Material Icons Two Tone';
  @extend %material-icon-base;
}

// Hide icon text until font is loaded to prevent FOUC
.icon-loading {
  visibility: hidden;
}